import { render } from "./Questions.vue?vue&type=template&id=b5088398&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=b5088398&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5088398"]])

export default __exports__